import { STUDENT_ROUTE } from 'app/routing-constants/student-routing.constant';

export const ASSESSMENT_ROUTE = {
  name: 'assessment',
  route(classId: string): string[] {
    return [...STUDENT_ROUTE.LOGGED.route(classId), 'assessment'];
  },

  DEFAULT: {
    name: ':activityId',
    route(classId: string, activityId: string): string[] {
      return [...ASSESSMENT_ROUTE.route(classId), activityId];
    }
  },

  QUESTION: {
    name: ':activityId/:questionOrder',
    route(classId: string, activityId: string, questionOrder: string): string[] {
      return [...ASSESSMENT_ROUTE.route(classId), activityId, questionOrder];
    }
  }
};
